"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DataTable = _interopRequireDefault(require("../../../../../data-table/DataTable"));

var _button = _interopRequireDefault(require("britive-design-system/core/components/button"));

var _checkbox = _interopRequireDefault(require("britive-design-system/core/components/checkbox"));

var _fa = require("react-icons/fa");

var _commonUtils = require("../../../../../../utils/common-utils");

var _constants = require("../../../../../policy/Members/constants");

var _utils = require("../add-users/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Tags = function Tags(_ref) {
  var selectedTags = _ref.selectedTags,
      setSelectedTags = _ref.setSelectedTags,
      setTagForMembers = _ref.setTagForMembers,
      setModalTitle = _ref.setModalTitle;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$membersReducer;

    return (_state$membersReducer = state.membersReducer) === null || _state$membersReducer === void 0 ? void 0 : _state$membersReducer.paginatedTags;
  }),
      result = _useSelector.result,
      status = _useSelector.status,
      count = _useSelector.count,
      size = _useSelector.size,
      page = _useSelector.page;

  (0, _react.useEffect)(function () {
    dispatch({
      type: _constants.UserTagsPaginatedType.USERS_TAGS_REQUEST,
      payload: {
        page: 0,
        size: 100
      }
    });
  }, []);

  var handleLocalSearch = function handleLocalSearch(value) {
    dispatch({
      type: _constants.UserTagsPaginatedType.USERS_TAGS_REQUEST,
      payload: {
        page: 0,
        size: 100,
        searchText: value !== null && value !== void 0 && value.length ? value : ''
      }
    });
  };

  var isLoading = status === 'LOADING';
  var totalPageCount = (0, _utils.getTotalPageCount)(count, size);

  var handleLoadMore = function handleLoadMore() {
    dispatch({
      type: _constants.UserTagsPaginatedType.USERS_TAGS_REQUEST,
      payload: {
        page: page + 1,
        size: 100
      }
    });
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DataTable.default, {
    rows: result,
    loadMore: !isLoading && page < totalPageCount,
    loadMoreHandler: handleLoadMore,
    loading: isLoading,
    inLineSort: true,
    searchBar: {
      onSearch: (0, _debounce.default)(handleLocalSearch, 300),
      placeholder: 'Search'
    },
    columns: [{
      headerName: 'Name',
      width: '50%',
      renderColumn: function renderColumn(row) {
        var itemIndex = selectedTags.findIndex(function (identity) {
          return identity.userTagId === row.userTagId;
        });
        var isChecked = itemIndex > -1;
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
          name: "checkbox-".concat(row.userTagId),
          checked: isChecked,
          onChange: function onChange(e) {
            var isItemChecked = e.target.checked;

            if (isItemChecked && !isChecked) {
              setSelectedTags([].concat(_toConsumableArray(selectedTags), [row]));
            } else if (isChecked) {
              var clonedSelectedItems = JSON.parse(JSON.stringify(selectedTags));
              clonedSelectedItems.splice(itemIndex, 1);
              setSelectedTags(clonedSelectedItems);
            }
          }
        }), "\xA0", row.name);
      }
    }, {
      headerName: 'Members',
      width: '20%',
      renderColumn: function renderColumn(row) {
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'flex'
          }
        }, row.userCount, "\xA0", /*#__PURE__*/_react.default.createElement(_button.default, {
          variant: "textOnly",
          size: "small",
          onClick: function onClick() {
            setTagForMembers(row.userTagId);
            setModalTitle(row.name);
          }
        }, row.userCount > 0 ? /*#__PURE__*/_react.default.createElement(_fa.FaSearch, {
          color: _commonUtils.blue60
        }) : null));
      }
    }, {
      field: 'status',
      headerName: 'Status',
      width: '30%'
    }]
  }));
};

Tags.propTypes = {
  selectedTags: _propTypes.default.array,
  setSelectedTags: _propTypes.default.func,
  setTagForMembers: _propTypes.default.func,
  setModalTitle: _propTypes.default.string
};
var _default = Tags;
exports.default = _default;